import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import routes from './routes.json';
import HomePage from './pages/HomePage';
import FAQPage from './pages/FAQPage';
import GlobalKidsPage from './pages/GlobalKidsPage';
import UnionSettlementPage from './pages/UnionSettlementPage';
import CoolCulturePage from './pages/CoolCulturePage';
import CalendarPage from './pages/CalendarPage';
import ComingSoonPage from './pages/ComingSoonPage';
import FormsDocumentsPage from './pages/FormsDocumentsPage';
import FoodPantryPage from './pages/FoodPantryPage';
import EventFlyersPage from './pages/EventFlyersPage';
import DualLanguagePage from './pages/DualLanguagePage';
import FacultyDirectoryPage from './pages/FacultyDirectoryPage';
import FacultyProfilePage from './pages/FacultyProfilePage';
import DirectionsPage from './pages/DirectionsPage';
import UniformPolicyPage from './pages/UniformPolicyPage';
import AnnouncementsPage from './pages/AnnouncementsPage';
import PrincipalMessagePage from './pages/PrincipalMessagePage';
import AboutUsPage from './pages/AboutUsPage';
import MissionStatementPage from './pages/MissionStatementPage';
import EarlyChildhoodPage from './pages/EarlyChildhoodPage';
import ElementaryPage from './pages/ElementaryPage';
import MiddleSchoolPage from './pages/MiddleSchoolPage';
import AfterSchoolPage from './pages/AfterSchoolPage';
import PartnershipsPage from './pages/PartnershipsPage';
import ContactUsPage from './pages/ContactUsPage';
import AttendancePolicyPage from './pages/AttendancePolicyPage';
import GreenTeamPage from './pages/GreenTeamPage';
import GirlsIncPage from './pages/GirlsIncPage';
import StudentCouncilPage from './pages/StudentCouncilPage';
import GalleryPage from './pages/GalleryPage';
import AsphaltGreenPage from './pages/AsphaltGreenPage';
import BeamCenterPage from './pages/BeamCenterPage';
import NewSchoolPage from './pages/NewSchoolPage';
import SpecialSubjectsPage from './pages/SpecialSubjectsPage';
import SchoolSpiritPage from './pages/SchoolSpiritPage';
import OurStudentsPage from './pages/OurStudentsPage';

// Single source of truth for routing lives in src/routes.json, which also
// drives static prerendering (scripts/prerender.mjs). To ADD a page: create the
// component, import it above, add it to `registry` below, and add a
// { path, component, title } entry to src/routes.json. To REMOVE a page: delete
// all four (component file, import, registry entry, routes.json entry).
const registry = {
  HomePage,
  FAQPage,
  GlobalKidsPage,
  UnionSettlementPage,
  CoolCulturePage,
  CalendarPage,
  ComingSoonPage,
  FormsDocumentsPage,
  FoodPantryPage,
  EventFlyersPage,
  DualLanguagePage,
  FacultyDirectoryPage,
  FacultyProfilePage,
  DirectionsPage,
  UniformPolicyPage,
  AnnouncementsPage,
  PrincipalMessagePage,
  AboutUsPage,
  MissionStatementPage,
  EarlyChildhoodPage,
  ElementaryPage,
  MiddleSchoolPage,
  AfterSchoolPage,
  PartnershipsPage,
  ContactUsPage,
  AttendancePolicyPage,
  GreenTeamPage,
  GirlsIncPage,
  StudentCouncilPage,
  GalleryPage,
  AsphaltGreenPage,
  BeamCenterPage,
  NewSchoolPage,
  SpecialSubjectsPage,
  SchoolSpiritPage,
  OurStudentsPage,
};

function App() {
  return (
    <Router>
      <Routes>
        {routes.map(({ path, component }) => {
          const C = registry[component];
          return C ? <Route key={path} path={path} element={<C />} /> : null;
        })}
      </Routes>
    </Router>
  );
}

export default App;
